export enum PermissionResource {
  INTEGRATION_TASK_EDITOR,
  INTEGRATION_SCHEDULER,
}
